import { Grid, InputAdornment } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import * as Yup from 'yup';
import { useSendContributionMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    reason: Yup.string().required().min(3).label('Reason/Type'),
    phone: Yup.string().required().min(9).max(10).label('Phone Number'),
    amount: Yup.number().required().label('Amount'),
});

export default function ContributionMpesaScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const [sendContribution, { isLoading }] = useSendContributionMutation();

    return (
        <Screen title="M-PESA">
            <Grid item xs={12}>
                <Form
                    validationSchema={validate}
                    initialValues={{ reason: '', phone: '', amount: '' }}
                    onSubmit={async (vals) => {
                        const { data, error } = await sendContribution({
                            ...vals,
                            phone: '254' + vals.phone,
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar(data?.message, {
                                variant: 'success',
                            });
                        }
                    }}
                >
                    <FormikInput name="reason" placeholder="Reason/Type" />
                    <FormikInput
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    +254
                                </InputAdornment>
                            ),
                        }}
                        name="phone"
                        placeholder="7XXXXXXXX"
                    />
                    <FormikInput name="amount" placeholder="Amount" />
                    <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <FormikButton variant="contained" loading={isLoading}>
                            Send
                        </FormikButton>
                    </div>
                </Form>
            </Grid>
        </Screen>
    );
}
